import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  Message,
  Table
} from '@alifd/next';
import styles from './index.module.scss';
import client from '../../../../lib/feathers';
import axios from 'axios';
import $ from "jquery";


const PayList = (props) => {
  const pay = client.service('pay');
  const message = client.service('message');
  const [payArr, setPayArr] = useState([]);
  const imgHd = 'https://bwipjs-api.metafloor.com/?bcid=code128&text=';
  // console.log(payArr)

  useEffect(() => {
    axios('/ezcon/api/getPayForm', {
      method: "GET",
      headers: { authorization: window.localStorage['feathers-jwt'] },
    }).then((response) => {
      console.log('Success:', response.data);
      $("form").append(`${response.data}`)
    }).catch(error => {
      console.error('Error', error);

    })
  }, []);


  function payFind(para) {
    return new Promise((resolve, reject) => {
      try {
        pay.find({ query: para }).then((result) => {
          resolve(result && result.data ? result.data : []);
        });

      } catch (error) {
        reject(error);
      }
    });
  }
  //新增
  function payCreate(obj) {
    return new Promise((resolve, reject) => {
      try {
        pay.create(obj).then((result) => {
          resolve(result);
        })


      } catch (error) {
        reject(error);
      }
    });
  }



  //更新
  function payUpdate(id, obj) {
    return new Promise((resolve, reject) => {
      // console.log(id, obj, params)
      pay.patch(id, obj).then((result) => {

        resolve(result);
      }).catch((error) => {
        reject(error)
      });
    });
  }
  //刪除
  function payRemove(id) {
    return new Promise((resolve, reject) => {
      try {
        pay.remove(id).then((result) => {
          resolve(result);
        })


      } catch (error) {
        reject(error);
      }
    });
  }


  // function updatedTimeSort(a, b) {
  //   return a.updatedTime < b.updatedTime ? 1 : -1;
  // }
  function serverDataUpdate() {
    payFind({}).then((result) => {
      setPayArr(result);
    });
  }
  useEffect(() => {

    serverDataUpdate();
  }, []);


  return (
    <>
       <form></form>
      <Table dataSource={payArr}>
        <Table.Column title="姓名" dataIndex="uName" width={150} />
        <Table.Column title="繳費狀態" width={100} cell={(record, index) => {
          return (
            <>
              <p>未繳款</p>
            </>
          );
        }} />
        <Table.Column title="繳費通知" width={100} cell={(record, index, value) => {
          // console.log(record, index, value)
          return (
            <>
              <Button type="primary" onClick={() => {
                // console.log(payArr[index].uid)

                axios('/ezcon/api/emitMsgQuery', {
                  method: "POST",
                  headers: { authorization: window.localStorage['feathers-jwt'] },
                  data: {
                   
                    service: "message",
                    event: "msg",
                    title: "繳費通知",
                    content: "尚未收到您的費用,趕快繳費拉!!",
                    type: "success",
                    duration: 8000,
                    redirect: "/ezpro/pay/payList",
                    query: {
                      _id: payArr[index].uid,
                      firebaseClass:"繳費系統",
                    }
                  }
                }).then((res) => {
                  console.log('==send message Success:', res.data);

                }).catch(error => {
                  console.error('==send message fail', error);

                })
              }
              }>通知</Button>
            </>
          );
        }} />

      </Table>

    </>
  );
};

export default PayList;
